
const EmployerShowcase = {
	slotCounter: 0,
	filterFlag: true,
	init: function() {
		console.log("EmployerShowcase initiaizing....");
		let affiliateId = sw_config.affiliateId;
		let widgetId = sw_config.rm_SwidgetId;
		window.utils.log("affiliateId: " + affiliateId + " widgetId: " + widgetId);
		EmployerShowcase.renderAffil(affiliateId, widgetId, EmployerShowcase.filterFlag);
	}, // END: init

	renderAffil: function(affiliateId, widgetId, filterFlag) {
		//render based on affil & widgetId
		console.log("EmployerShowcase rendering data....");
		let dataSource = EmployerShowcaseDataSource.endpoint;
		if (dataSource == null || dataSource == '') {
			dataSource = "https://0vq471i9sl.execute-api.us-east-1.amazonaws.com/dev/"; //default
		}

		let employerEndPoint_original =
			"http://jobs.thejobnetwork.com/RMAPI/widgets/Widget.svc/GetFeaturedEmployers?header={%22AffiliateId%22:" +
			affiliateId +
			"}&body={%22affiliateId%22:" +
			affiliateId +
			",%22WidgetId%22:" +
			widgetId +
			",%22RelevanceMinPercent%22:30}";

		let employerEndPoint = dataSource + "?query=%7BgetFullData(affiliateId%3A" + affiliateId + "%2CwidgetId%3A" + widgetId + "%2CfilterFlag%3A" + filterFlag + ")%7D";

		window.utils.log("original Featured Employers API EndPoint: " + employerEndPoint_original);
		window.utils.log("GraphQL-filtered Featured Employers API EndPoint: " + employerEndPoint);

		EmployerShowcase.render(employerEndPoint);
	}, // END: renderAffil

	render: function(employerEndPoint) {
		$.getJSON(employerEndPoint, {
			format: "json"
		}).done(function(response) {
			window.utils.log("response:" + JSON.stringify(response));
			let getFullData = JSON.parse(response.data.getFullData); //need to parse bec graphql returned items as stringified obj

			let columnDisplayMode = "";
			let columnCount = getFullData.column_count;
			window.utils.log("columnCount: " + columnCount);
			if (columnCount > 0) EmployerShowcase.showColumns(); //show double and single?
			if (columnCount == 1) columnDisplayMode = "single";
			if (columnCount == 2) columnDisplayMode = "double";

			let slotCounter = 0;

			$.each(getFullData.featured_employers, function(i, item) {
				let companyId = item.company_id;
				window.utils.log("companyId: " + companyId);
				let companyName = item.company_name;
				window.utils.log("companyName:" + companyName);
				let companyProfile = item.company_profile + "...";
				window.utils.log("companyProfile: " + companyProfile);
				let companyProfileUrl = "http://jobs." + sw_config.affil_com + "/femployer.aspx?CompanyId=" + companyId;
				//let companyLogoUrl = "https://fileserver.thejobnetwork.com/Content/Public/ClientsLogo/" + companyId + ".jpg";
				let companyLogoUrl = item.company_logo_url;

				window.utils.log("rendering html for featured employers column display...............");
				//compose html elements
				let html_column =
					"<li><div class='box'><div class='logo-wrap' onclick='location.href=\"" +
					companyProfileUrl +
					"\"' style='background-image: url(\"" +
					companyLogoUrl +
					"\")' />";
				html_column = html_column + "<div class='dataset'><h3 class='company-name'>" + companyName + "</h3>";
				html_column = html_column + "<p class='company-profile'>" + companyProfile + "</p>";
				html_column = html_column + "</div>";

				html_column = html_column + "<div class='btn_wrap'><a href='" + companyProfileUrl + "' title='Read More' class='btn_learnmore'>";
				html_column = html_column + "<span class='learnmore_button'>Read More</span></a></div>";
				html_column = html_column + "</div></li>";

				$("#columnslots").addClass(columnDisplayMode);
				$("#columnslots").append(html_column);

				EmployerShowcase.slotCounter++;

				if (EmployerShowcase.slotCounter === columnCount) {
					//stop after filling in the 3 slots
					return false;
				}
			}); // END: .each
		}); // END: done()
	}, // END: render

	showColumns: function() {
		//show label, text and columns if data set passes criteria
		$(".section--employershowcase .box_wrap").show();
		$(".section--employershowcase .section__label").show();
		$(".section--employershowcase .section__body .text").show();
	} //END: showColumns
};

$(document).ready(function() {
	EmployerShowcase.init();
});

window.EmployerShowcase = EmployerShowcase;
